import Reveal from "./Reveal";
import { PLACEHOLDER_IMAGE_HERO } from "../../lib/constants";

export default function Hero({ whatsappNumber, content, uiStrings, elementVisibility, sectionId, servicesHref }) {
  const HERO_BG = content?.bg_image || PLACEHOLDER_IMAGE_HERO;

  const imgAlt = content?.img_alt || "";
  const waMsg = uiStrings?.general?.whatsapp_message || content?.whatsapp_message || "";
  const scrollText = uiStrings?.general?.scroll || "";
  
  const waDigits = (whatsappNumber || "").replace(/\D/g, "");
  const waLink = `https://wa.me/${waDigits}?text=${encodeURIComponent(waMsg)}`;

  const srcset = HERO_BG.includes("unsplash")
    ? `${HERO_BG.replace(/w=\d+/, "w=800")} 800w, ${HERO_BG.replace(/w=\d+/, "w=1200")} 1200w, ${HERO_BG.replace(/w=\d+/, "w=1600")} 1600w, ${HERO_BG.replace(/w=\d+/, "w=2400")} 2400w`
    : undefined;

  return (
    <section
      data-id="site-hero"
      id={sectionId}
      className="relative h-[100dvh] min-h-[560px] md:min-h-[640px] w-full overflow-hidden grain"
    >
      <div data-id="hero-bg-wrapper" className="absolute inset-0">
        <img data-id="hero-bg-image"
          src={HERO_BG}
          srcSet={srcset}
          sizes="100vw"
          alt={imgAlt}
          className="w-full h-full object-cover animate-kenburns"
          fetchpriority="high"
          loading="eager"
        />
      </div>
      <div data-id="hero-gradient-top" className="absolute inset-0 bg-gradient-to-t from-softblack/80 via-softblack/40 to-softblack/30" />
      <div data-id="hero-gradient-right" className="absolute inset-0 bg-gradient-to-r from-softblack/40 via-transparent to-transparent" />
      <div data-id="hero-gradient-radial"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(80% 50% at 75% 30%, rgba(200,169,126,0.18), transparent 70%)",
        }}
      />

      <div data-id="hero-content" className="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-28">
        <Reveal delay={150}>
          <p className="eyebrow !text-fendi/90" data-id="hero-eyebrow">
            {content?.eyebrow || ""}
          </p>
        </Reveal>
        <Reveal delay={300}>
          <h1
            data-id="hero-headline"
            className="font-serif text-offwhite mt-6 max-w-4xl text-[clamp(32px,7vw,80px)] leading-[1.05] lg:leading-[0.98] tracking-tight"
          >
            {content?.headline || ""}
          </h1>
        </Reveal>
        <Reveal delay={500}>
          <p
            data-id="hero-subheadline"
            className="text-fendi/90 mt-6 md:mt-8 max-w-xl text-sm sm:text-base md:text-lg font-light leading-relaxed"
          >
            {content?.subheadline || ""}
          </p>
        </Reveal>
        {elementVisibility?.hero_cta !== false && (
          <Reveal delay={700}>
            <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-3" data-id="hero-actions">
              <a href={servicesHref || "#servicos"} data-id="hero-cta-services" className="btn-light text-center">
                {uiStrings?.general?.cta_secondary || content?.cta_secondary || ""}
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-id="hero-cta-whatsapp"
                className="btn-light text-center"
              >
                {uiStrings?.general?.cta_primary || content?.cta_primary || ""}
              </a>
            </div>
          </Reveal>
        )}

        {elementVisibility?.hero_scroll !== false && (
          <div data-id="hero-scroll" className="absolute bottom-10 right-10 hidden md:flex flex-col items-center gap-3 text-fendi/70">
            <span data-id="hero-scroll-text" className="eyebrow !text-fendi/60 rotate-90 origin-center mt-12 mb-12">{scrollText}</span>
            <div data-id="hero-scroll-line" className="w-px h-16 bg-fendi/40" />
          </div>
        )}
      </div>
    </section>
  );
}
